export type TagList = string[] | undefined | null

export const hasTag = (tags: TagList, tag?: string) => {
  if (!tag || !Array.isArray(tags)) {
    return false
  }

  return tags.includes(tag)
}
